import styled from 'styled-components';

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const Subtitle = styled.p`
  margin-top: 8px;
  font-size: 14px;
  color: #6b7280;
`;

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 30px;
`;

export const DownloadCard = styled.div<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  padding: 18px;
  border-radius: 14px;
  background: white;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid transparent;

  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
    border-color: #6366f1;
  }
`;

export const IconContainer = styled.div`
  font-size: 22px;
  margin-right: 14px;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.span`
  font-weight: 600;
  font-size: 15px;
  color: #111827;
`;

export const Description = styled.span`
  font-size: 13px;
  color: #6b7280;
  margin-top: 3px;
`;
